import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LeitorAutocomplete from '../../components/autocomplete/LeitorAutocomplete'
import Donutchart from '../../components/charts/DonutChart'
import { getPostagens } from '../../components/charts/functions'
import RadialBar from '../../components/charts/RadialBar'
import FloatFilter from '../../components/FloatFilter'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import BaseDatePicker from '../../components/shared/BaseDatePicker'
import Dater from '../../services/DateFormat'
import { Relatorios } from '../../services/http'
import getLeitor from '../../services/http/user/getLeitor'
import ColaboradorDatacard from '../dashboard/components/ColaboradorDatacard'
import { getMinDate } from '../postagens/functions'
import { ChartTitle, StyledDP } from './components'
import Gestao from './components/Gestao'
import LineChart from './components/LineChart'
import PopoverMedal from './components/PopoverMedal'
import PopperPopupState from './components/PopoverTroph'

const ColaboradorDashBoard = () => {
  const [query, setQuery] = useState({})
  const [postagens, setPostagens] = useState([])
  const [currentUser, setCurrentUser] = useState(null)
  const [filters, setFilters] = useState({
    ano_id: '',
    leitor_id: ''
  })

  const [meta, setMeta] = useState(false)
  const [relatorio, setRelatorio] = useState([])
  const [metaMesPostagem, setMetaMesPostagem] = useState(0)

  useEffect(() => {
    init()
  }, [])

  const _ = React

  const mesesDoAno = [
    'janeiro',
    'fevereiro',
    'marco',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
  ]

  async function init() {
    const leitor = await getLeitor()
    setCurrentUser(leitor[0])

    setFilters({
      ...filters,
      leitor_id: leitor[0].id,
      ano_id: getMinDate().getFullYear()
    })
    setQuery({ year: getMinDate() })
  }

  function processaRelatorio(relatorios) {
    let count = 0
    if (relatorios?.length > 0) {
      mesesDoAno.forEach(item => {
        if (relatorios[0][item] === 1) {
          count++
          setMetaMesPostagem(count)
        }
      })
    }
  }

  const getRelatorios = async (leitor_id, ano) => {
    if (!leitor_id) return
    const { data } = await Relatorios().show({
      leitor_id,
      ano
    })
    setRelatorio(data.data)
    processaRelatorio(data.data[0])
  }

  function updateQuery(value) {
    setQuery({ ...query, ...value })
  }

  async function gets(filters) {
    const result = await getPostagens(filters)
    setPostagens([...result])
  }

  useEffect(() => {
    const date = getMinDate()
    getRelatorios(filters.leitor_id, filters.ano_id || date.getFullYear())
    gets(filters)
  }, [filters])

  const checkNPages = pages => pages > 1999

  return (
    <Box sx={{ mt: 5 }}>
      {meta && <PopperPopupState />}

      {checkNPages(relatorio[0]?.numero_paginas) ? (
        <PopoverMedal nLeiturasMes={metaMesPostagem} />
      ) : (
        <div></div>
      )}

      <FloatFilter>
        <>
          <LeitorAutocomplete
            sx={{ mb: 1 }}
            onChange={value => {
              setFilters({ ...filters, leitor_id: value || currentUser.id })
            }}
          />
          <BaseDatePicker
            minDate={'2023-01-01'}
            maxDate={parseInt(Dater().formatar(new Date(), 'yyyy')) + '-12-31'}
            value={query.year}
            onChange={date => {
              if (!date) return
              updateQuery({ ...query, year: date })
              setFilters({ ...filters, ano_id: date.$y })
            }}
            label="Ano"
            inputFormat="YYYY"
            openTo="year"
            views={['year']}
            clearable={false}
          />
        </>
      </FloatFilter>
      <AdaptativeGridContainer
        style={{ justifyContent: 'space-between', padding: '0 1rem' }}
      >
        <ColaboradorDatacard filters={filters} meta={meta} />
      </AdaptativeGridContainer>
      <AdaptativeGridContainer
        sx={{ mt: '24px', justifyContent: 'space-between' }}
      >
        <>
          <Grid sx={{ marginBottom: '3vh' }} item xs={12} sm={5.9}>
            <StyledDP sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
              <ChartTitle>Número de páginas aprovadas</ChartTitle>
              <Gestao relatorioData={relatorio} />
              <RadialBar
                postagens={postagens}
                changeMeta={meta => setMeta(meta)}
              />
            </StyledDP>
          </Grid>
          <Grid
            item
            xs={12}
            sm={5.9}
            sx={{
              marginTop: { xs: '4vh', sm: '4h', md: '0vh' },
              marginBottom: '3vh'
            }}
          >
            <StyledDP sx={{ p: 1 }}>
              <ChartTitle>Porcentagem de categorias lidas</ChartTitle>
              <Donutchart postagens={postagens} />
            </StyledDP>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              marginTop: { xs: '4vh', sm: '4h', md: '0vh' },
              marginBottom: '4vh'
            }}
          >
            <StyledDP sx={{ p: 1 }} elevation="0">
              <ChartTitle>Páginas lidas por mês</ChartTitle>
              <LineChart meta={meta} postagens={postagens} />
            </StyledDP>
          </Grid>
        </>
      </AdaptativeGridContainer>
    </Box>
  )
}

export default ColaboradorDashBoard
